<template>
  <div>
    <div class="row columns">
      <div class="large-12 columns">
        <div class="note text-left">modifier les stats en cliquant sur les icônes + et -</div>
        <div class="note text-left alert">ATTENTION : ces augmentations de caractéristiques sont <strong>totalement</strong> gratuites,
          en terme de XP, ou de coût du joueur.</div>
      </div>
    </div>
    <br>
    <table>
       <thead class="roster-head">
        <tr>
          <th>Stat.</th>
          <th >Actuelle</th>
          <th >Customisation</th>
          <th >Total</th>
          <th >action</th>
      </tr>
      </thead>
      <tbody class="large-font">
      <tr>
        <td width="10%">M.</td>
        <td width="25%" class="stat">{{detailedPlayer.M}}</td>
        <td width="25%" class="stat">{{M_offset}}</td>
        <td width="25%" class="stat">{{detailedPlayer.M + M_offset}}</td>
        <td width="25%" class="button-column">
          <button @click="M_offset += 1">
            <span class="large-btn-icon"><i class="fa fa-plus" aria-hidden="true"></i></span>
          </button>
          <button @click="M_offset -= 1">
            <span class="large-btn-icon"><i class="fa fa-minus" aria-hidden="true"></i></span>
          </button>
        </td>
      </tr>
      <tr>
        <td>F.</td>
        <td class="stat">{{detailedPlayer.F}}</td>
        <td class="stat">{{F_offset}}</td>
        <td class="stat">{{detailedPlayer.F + F_offset}}</td>
        <td class="button-column">
          <button @click="F_offset += 1">
            <span class="large-btn-icon"><i class="fa fa-plus" aria-hidden="true"></i></span>
          </button>
          <button @click="F_offset -= 1">
            <span class="large-btn-icon"><i class="fa fa-minus" aria-hidden="true"></i></span>
          </button>
        </td>
      </tr>
      <tr>
        <td>Ag.</td>
        <td class="stat">{{detailedPlayer.Ag}}</td>
        <td class="stat">{{Ag_offset}}</td>
        <td class="stat">{{detailedPlayer.Ag + Ag_offset}}</td>
        <td class="button-column">
          <button @click="Ag_offset += 1">
            <span class="large-btn-icon"><i class="fa fa-plus" aria-hidden="true"></i></span>
          </button>
          <button @click="Ag_offset -= 1">
            <span class="large-btn-icon"><i class="fa fa-minus" aria-hidden="true"></i></span>
          </button>
        </td>
      </tr>
      <tr>
        <td>Ar.</td>
        <td class="stat">{{detailedPlayer.Ar}}</td>
        <td class="stat">{{Ar_offset}}</td>
        <td class="stat">{{detailedPlayer.Ar + Ar_offset}}</td>
        <td class="button-column">
          <button @click="Ar_offset += 1">
            <span class="large-btn-icon"><i class="fa fa-plus" aria-hidden="true"></i></span>
          </button>
          <button @click="Ar_offset -= 1">
            <span class="large-btn-icon"><i class="fa fa-minus" aria-hidden="true"></i></span>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
    <button @click="reset()" class="alert">
      <span class="large-btn-icon"><i class="fa fa-minus" aria-hidden="true"></i>&nbsp;Réinitialiser</span>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'stats-customizer',
    props: {
      'detailedPlayer': {}
    },
    data () {
      return {
        M_offset: 0,
        F_offset: 0,
        Ag_offset: 0,
        Ar_offset: 0
      }
    },
    methods: {
      reset: function () {
        this.M_offset = 0
        this.F_offset = 0
        this.Ag_offset = 0
        this.Ar_offset = 0
      },
      isUsed: function () {
        if (this.M_offset !== 0 ||
            this.F_offset !== 0 ||
            this.Ag_offset !== 0 ||
            this.Ar_offset !== 0) {
          return true
        }
        return false
      }
    }
  }
</script>

<style scoped>
thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

tbody.large-font tr td{
    padding: 0.3rem 0.2rem;
    text-align: center;
    font-size:1.1rem;
}
tr td input, tr td select{
    padding: 0.5rem 0.5rem;
    text-align: center;
    font-size:0.7rem;
    margin: 0rem;
}

.large-font {
  font-size: 1.1rem
}
.button-column {
  text-align: right;
}
.note {
  font-size: 0.8rem;
  font-weight: 200;
}
.stat {
  font-weight: 300;
}
.alert {
  color:#E7505A;
}
button.alert {
  color:#FFFFFF;
}
</style>



// WEBPACK FOOTER //
// stats-customizer.vue?101de0d6